import { action } from "mobx";
import { inject, observer } from "mobx-react";
import * as moment from 'moment-timezone';
import * as React from "react";
import { Prompt, withRouter } from "react-router";
import { Button, Col, Row, Table } from "reactstrap";
import ButtonRow from "src/Components/ButtonRow";
import { EInputMask } from "src/Components/EInput";
import { WellFooter } from "src/Components/Footer/WellFooter";
import OpenArrow from "src/Components/OpenArrow/OpenArrow";
import { WellsStore } from "src/Stores/Wells/WellsStore";
import WorkflowHeader from "../../WorkflowHeader/WorkflowHeader";
import WellCloseButton from "../WellCloseButton";
import WellRevertCloseButton from "../WellRevertCloseButton";
import IntervalViewTable from "./IntervalViewTable";

const mask = new EInputMask();

@inject('stores')
@observer
class RecapRemarksReview extends React.Component {
    public props: any;
    private WellsStore: WellsStore; 

    public state = {
        isDirty: false,
        wellRemarksEditable: [] as boolean[],
        wellTestClosed: [] as boolean[],
    };

    constructor(props: any) {
        super(props);
        this.WellsStore = props.stores.WellsStore;
    }

    public componentDidMount() {
        if (this.WellsStore.well) {
            this.WellsStore.getWellCloseReview();
        } else {
            this.WellsStore.getWellDetails(this.props.match.params.wellId)
                .then(() => {
                    this.WellsStore.getWellCloseReview();
                });
        }
    }

    private toggleWellTestOpen = (index: number) => () => {
        const wellTestClosed = this.state.wellTestClosed;
        wellTestClosed[index] = !this.state.wellTestClosed[index];
        this.setState({wellTestClosed});
    }

    private toggleWellRemarksEditable = (index: number) => () => {
        const wellRemarksEditable = this.state.wellRemarksEditable;
        wellRemarksEditable[index] = !this.state.wellRemarksEditable[index];
        this.setState({wellRemarksEditable});
    }

    private enableEditingAll = () => {
        const wellRemarksEditable = new Array(this.WellsStore.wellCloseReview.remarks.length).fill(true);
        this.setState({
            wellRemarksEditable
        });
    }

    private disableEditingAll = () => {
        const wellRemarksEditable = [] as boolean[];
        this.setState({
            wellRemarksEditable
        });
    }

    @action
    private handleMudReportRecapChange = (index: number) => (event: any) => {
        this.WellsStore.wellCloseReview.remarks[index].remarks.mudReportRecap = event.target.value;
        this.setState({isDirty: true});
    }

    @action
    private handleAdditionalChange = (index: number) => (event: any) => {
        this.WellsStore.wellCloseReview.remarks[index].remarks.additional = event.target.value;
        this.setState({isDirty: true});
    }

    private updateWellCloseReview = () => {
        this.WellsStore.saveWellCloseReview(this.WellsStore.wellCloseReview)
            .then(data => {
                if (data) {
                    this.setState({isDirty: false});
                }
            });
    }

    private expandAllWellTest = () => {
        const wellTestClosed = new Array(this.WellsStore.wellCloseReview.remarks.length).fill(false);
        this.setState({wellTestClosed});
    }

    private collapseAllWellTest = () => {
        const wellTestClosed = new Array(this.WellsStore.wellCloseReview.remarks.length).fill(true);
        this.setState({wellTestClosed});
    }

    private buttonNavigation = (event: any) => {
        const $target = event.target;
        if ( $target.name === 'previousButton' ) {
            this.props.history.push('/well/' + this.props.match.params.wellId + '/wellclose/volumeaccountingreview');
        } else {
            this.props.history.push('/well/' + this.props.match.params.wellId + '/wellclose/volumeaccounting');
        }
    }

    public render() {
        const wellCloseReview = this.WellsStore.wellCloseReview;
        if (wellCloseReview === undefined) {
            return <div>
            <WorkflowHeader workflowHeaderItems={this.props.workflowHeaderItems}/>
            </div>;
        }
        const wellCloseWellTestRemarks = wellCloseReview.remarks;
        const wellCloseWellTestFinal = wellCloseWellTestRemarks.length > 0
            ? wellCloseWellTestRemarks[wellCloseWellTestRemarks.length - 1]
            : undefined;
        return <div className="WellCloseReview">
            <Prompt when={this.state.isDirty} message={"Changes have been made.\n\nPress Cancel then Press Save OR Press OK to continue without saving."} />
            <WorkflowHeader workflowHeaderItems={this.props.workflowHeaderItems}/>
            <Row>
                <IntervalViewTable />
                <Col md={4}>
                    <div className="data-table-component">
                        <Table>
                            <thead>
                                <tr>
                                    <th />
                                    <th style={{textAlign: 'center'}}>
                                        MD
                                    </th>
                                    <th style={{textAlign: 'center'}}>
                                        TVD
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th>
                                        KOP
                                    </th>
                                    <td>
                                        { wellCloseWellTestFinal && wellCloseWellTestFinal.kopMD }
                                    </td>
                                    <td>
                                        { wellCloseWellTestFinal && wellCloseWellTestFinal.kopTVD }
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        EOC
                                    </th>
                                    <td>
                                        { wellCloseWellTestFinal && wellCloseWellTestFinal.eocMD }
                                    </td>
                                    <td>
                                        { wellCloseWellTestFinal && wellCloseWellTestFinal.eocTVD }
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>
                </Col>
            </Row>
            <Row style={{marginBottom: '1rem'}}>
                <Col>
                    <Button color="primary" onClick={this.expandAllWellTest}>Expand All Tests</Button>
                    {' '}
                    <Button color="primary" onClick={this.collapseAllWellTest}>Collapse All Tests</Button>
                    {' '}
                    <Button color="primary" onClick={this.enableEditingAll}>Enable Editing for All Tests</Button>
                    {' '}
                    <Button color="primary" onClick={this.disableEditingAll}>Disable Editing for All Tests</Button>
                </Col>
            </Row>
            <Row>
                <Col>
                
            {
                wellCloseWellTestRemarks.map((wtRem, index) => 
                    <React.Fragment key={wtRem.id ? wtRem.id : index}>
                        <h4 className="accordian-h4">
                            <span onClick={this.toggleWellTestOpen(index)}>
                                <OpenArrow open={!this.state.wellTestClosed[index]}/>{moment.unix(wtRem.testDate).tz(this.WellsStore.well.timeZoneName).format("MMM DD YYYY, h:mm a")}
                            </span>{' '}
                            {' '}| MD: {wtRem.depthMD.toFixed(0)}
                            {' '}| TVD: {wtRem.depthTVD.toFixed(0)}
                            {' '}| BD: {wtRem.depthBit.toFixed(0)}
                            {' '}| {wtRem.presentActivity}
                            {' '}{ wtRem.isNewIntervalReport ? '| New Interval ' : ''}
                            {' '}| { wtRem.fluidSubType}
                            {' '}| Daily: { mask.currency(wtRem.dailyCost)}
                            {' '}| Cumulative: { mask.currency(wtRem.cumulativeCost)}
                            {' '}|
                            <span style={{marginLeft: '2rem'}}>
                                <input
                                    type="checkbox"
                                    name={"wellRemarksEditable" + index}
                                    id={"wellRemarksEditable" + index}
                                    checked={this.state.wellRemarksEditable[index]}
                                    onClick={this.toggleWellRemarksEditable(index)}
                                />
                                Edit
                            </span>
                        </h4>
                        { !this.state.wellTestClosed[index] &&
                            <div className="well-story">
                                <textarea
                                    name={"mudReportRecap" + index}
                                    id={"mudReportRecap" + index}
                                    rows={6}
                                    value={wtRem.remarks.mudReportRecap}
                                    onChange={this.handleMudReportRecapChange(index)}
                                    disabled={!this.state.wellRemarksEditable[index]}
                                />
                                <p className="remark-datetime">
                                    Mud Report/Recap Remark
                                </p>
                            </div>
                        }
                        {   !this.state.wellTestClosed[index] &&
                            wtRem.remarks.recapSuggestion &&
                            <div className="well-story">
                                <p>{wtRem.remarks.recapSuggestion}</p>
                                <p>Recap Suggestion</p>
                            </div>
                        }
                        {   !this.state.wellTestClosed[index] &&
                            <div className="well-story">
                                <textarea
                                    name={"additonal" + index}
                                    id={"additional" + index}
                                    rows={6}
                                    value={wtRem.remarks.additional}
                                    onChange={this.handleAdditionalChange(index)}
                                    disabled={!this.state.wellRemarksEditable[index]}
                                />
                                <p className="remark-datetime">
                                    Additional Recap Remark
                                </p>
                            </div>
                        }
                        {
                            !this.state.wellTestClosed[index] &&
                            wtRem.remarks.additionalRecapSuggestion &&
                            <div className="well-story">
                                <p>{wtRem.remarks.additionalRecapSuggestion}</p>
                                <p>Additional Recap Suggestion</p>
                            </div>
                        }
                    </React.Fragment>
                )
            }
                </Col>
            </Row>
            <ButtonRow>
                <WellRevertCloseButton />
                <WellCloseButton />
                { this.WellsStore.canUpdateWell() && <Button color="primary" name="save" onClick={this.updateWellCloseReview}>Save</Button>}
                <Button className="secondary" name="previousButton" onClick={this.buttonNavigation}>Previous</Button>
                <WellFooter />
            </ButtonRow>
        </div>;
    }
}

export default withRouter(RecapRemarksReview);


// WEBPACK FOOTER //
// ./src/Components/Main/WellWorkflow/WellClose/RecapRemarksReview.tsx